import { FaCropAlt, FaRedo } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatCropMaskStatus } from "./installationConfigUtils";
import InstallationPhotoCaptureSection from "./InstallationPhotoCaptureSection";
import InstallationSideContainersSection from "./InstallationSideContainersSection";
import { InstallationPickerRow } from "./InstallationPickerSheet";

const InstallationSideHubSection = ({
  routeCameraId,
  side,
  camera,
  corporationId,
  addressId,
  api,
  token,
  configData,
  onPhotoSave,
  onContainersSave,
  rotationSubtitle,
  disabled,
  saving,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const basePath = `/app/installationdetails/${routeCameraId}/visualization/${side}`;

  const openRotation = () => {
    history.push(`${basePath}/rotation`);
  };

  const openMask = () => {
    history.push(`${basePath}/mask`);
  };

  return (
    <div className="installation-settings-card">
      <InstallationPickerRow
        icon={FaRedo}
        iconVariant={side === "right" ? "rotation-right" : "rotation-left"}
        title={t("installation_side_hub_rotation")}
        subtitle={rotationSubtitle}
        onClick={openRotation}
        disabled={disabled || saving}
      />
      <InstallationPickerRow
        icon={FaCropAlt}
        iconVariant="mask"
        title={t("installation_side_hub_mask")}
        subtitle={formatCropMaskStatus(t, configData, side)}
        onClick={openMask}
        disabled={disabled || saving}
        divided
      />
      <InstallationPhotoCaptureSection
        configData={configData}
        side={side}
        onPhotoSave={onPhotoSave}
        disabled={disabled}
        saving={saving}
        divided
      />
      <InstallationSideContainersSection
        api={api}
        token={token}
        corporationId={corporationId}
        addressId={addressId}
        selectedContainerIds={camera?.containerObjectIdList}
        onContainersSave={onContainersSave}
        disabled={disabled}
        saving={saving}
        divided
      />
    </div>
  );
};

export default InstallationSideHubSection;
